import { getCookieValue } from './getCookieValue';
import { COOKIE_KEYS } from './constants';
import { Cookie } from './types';

export const AB_CONSTANTS = {
    COOKIE_SHARED_CONTROL: 'CC',
    COOKIE_SHARED_INELIGIBLE: 'XX',
    CDN_TEST_1: 'cdnTest1',
    CDN_TEST_2: 'cdnTest2',
    CDN_TEST_3: 'cdnTest3',
    CDN_TEST_4: 'cdnTest4',
    SHARED_CONTROL_GROUP: 'sc',
    TRAFFIC_DISTRIBUTION: 'ds',
};

type EligbilityResult = {
    group: string;
    eligibility: string;
};

const INELIGIBLE_RESULT: EligbilityResult = {
    group: AB_CONSTANTS.COOKIE_SHARED_INELIGIBLE,
    eligibility: '',
};

const getEligibleGroup = (fields: string[] = []): EligbilityResult => {
    const groups = fields.map(field => {
        const groupAndEligibility = field.split('^');
        return { group: groupAndEligibility[0], eligibility: groupAndEligibility[1] };
    });

    return (
        groups.find(({ group, eligibility }) => !!group && !isNaN(Number(eligibility))) ||
        INELIGIBLE_RESULT
    );
};

const getAbTestCookie = (cookie: Cookie): string =>
    getCookieValue(cookie, COOKIE_KEYS.AB_TEST_ELIGIBILITY) || '';

export function getAbTestEligibility(cookie: Cookie): EligbilityResult {
    const abTestCookie = getAbTestCookie(cookie);
    if (!abTestCookie) {
        return INELIGIBLE_RESULT;
    }

    const eligibilityFields = abTestCookie
        .split(':')
        .filter(field => /(cdnTest\d|sc).*\^\d\d/.test(field)); // ignore fields like ds^10 and vs^01
    return getEligibleGroup(eligibilityFields);
}

export const isInAllocationRange = ({
    cookie,
    MIN,
    MAX,
}: {
    cookie: Cookie;
    MIN: number;
    MAX: number;
}): boolean => {
    const abTestCookie = getAbTestCookie(cookie);
    // Feature ramping in CDN is being detected by "ds" part of the cookie.
    // So to match that and have correct tracking we do the same on client.
    const trafficDistributionField = abTestCookie
        .split(':')
        .find(field => field.includes(AB_CONSTANTS.TRAFFIC_DISTRIBUTION));
    const eligibility = getEligibleGroup([trafficDistributionField || '']).eligibility;
    const allocation = parseInt(eligibility, 10);

    return allocation >= MIN && allocation <= MAX;
};
